import { ReactElement } from "react"
import { RouteData } from "src/model"
import access from "./localAccess"

const routeData = (path: string, name: string, component: ReactElement<any, any>): RouteData => {
    return { 
        routeProps: {
            path,
            element: component
        },
        name
    }
}

const splitCamelCase = (text: string, isTitleCase?: boolean) => {
    let result = text.replace(/([a-z])([A-Z])/g, '$1 $2')
    result = isTitleCase ? result[0].toUpperCase() + result.substring(1) : result 
    return result
}

export const erroMessage = (text: any) => {
    const isOnline = access.getInternetStatus()
    return !isOnline ? 'No Internet Connection' : `Message: ${text || 'An error occured'}`
}

export const catchErrMsg = (err: any) => {
    let message = err?.response?.data?.message
    
    if (err.response?.status === 500) message = 'Something went wrong (Server)'
    return message 
}

export default {
    routeData,
    splitCamelCase,
    erroMessage,
    catchErrMsg
}